/**
 * @class 	mapLegend
 * @brief 	The mapLegend library is responsible for helping setup the map legend in the STAT compiler Dashboard.
 * @details
 * @version 	0.1
 * @date 	08/04/2014
 */
var mapLegend = (function() {
  /**
   * @brief Cool stuff.
   */
  var _MIN = 'minValue';
  var _MAX = 'maxValue';
  var _LABEL = 'label';
  var _COLOR = 'color';
  const _MAX_COLOR_CHIPS = 6;

  /**
   * @brief An array of color swatches to help represent the map.
   */
  var _arrLengendSchemes = [
    ['#b30000', '#e34a33', '#fc8d59', '#fdbb84', '#fdd49e', '#fef0d9'],
    ['#fef0d9', '#fdd49e', '#fdbb84', '#fc8d59', '#e34a33', '#b30000'],
    ['#006d2c', '#2ca25f', '#66c2a4', '#99d8c9', '#ccece6', '#edf8fb'],
    ['#edf8fb', '#ccece6', '#99d8c9', '#66c2a4', '#2ca25f', '#006d2c'],
    ['#810f7c', '#8856a7', '#8c96c6', '#9ebcda', '#bfd3e6', '#edf8fb'],
    ['#edf8fb', '#bfd3e6', '#9ebcda', '#8c96c6', '#8856a7', '#810f7c'],
    ['#0868ac', '#43a2ca', '#7bccc4', '#a8ddb5', '#ccebc5', '#f0f9e8'],
    ['#f0f9e8', '#ccebc5', '#a8ddb5', '#7bccc4', '#43a2ca', '#0868ac'],
    ['#980043', '#dd1c77', '#df65b0', '#c994c7', '#d4b9da', '#f1eef6'],
    ['#f1eef6', '#d4b9da', '#c994c7', '#df65b0', '#dd1c77', '#980043'],
  ];

  var _arrObjLengendSchemes = [
    {
      value: '0',
      color6: '#fef0d9',
      color5: '#fdd49e',
      color4: '#fdbb84',
      color3: '#fc8d59',
      color2: '#e34a33',
      color1: '#b30000',
      mirror: false,
    },
    {
      value: '1',
      color6: '#b30000',
      color5: '#e34a33',
      color4: '#fc8d59',
      color3: '#fdbb84',
      color2: '#fdd49e',
      color1: '#fef0d9',
      mirror: true,
    },
    {
      value: '2',
      color6: '#edf8fb',
      color5: '#ccece6',
      color4: '#99d8c9',
      color3: '#66c2a4',
      color2: '#2ca25f',
      color1: '#006d2c',
      mirror: false,
    },
    {
      value: '3',
      color6: '#006d2c',
      color5: '#2ca25f',
      color4: '#66c2a4',
      color3: '#99d8c9',
      color2: '#ccece6',
      color1: '#edf8fb',
      mirror: true,
    },
    {
      value: '4',
      color6: '#edf8fb',
      color5: '#bfd3e6',
      color4: '#9ebcda',
      color3: '#8c96c6',
      color2: '#8856a7',
      color1: '#810f7c',
      mirror: false,
    },
    {
      value: '5',
      color6: '#810f7c',
      color5: '#8856a7',
      color4: '#8c96c6',
      color3: '#9ebcda',
      color2: '#bfd3e6',
      color1: '#edf8fb',
      mirror: true,
    },
    {
      value: '6',
      color6: '#f0f9e8',
      color5: '#ccebc5',
      color4: '#a8ddb5',
      color3: '#7bccc4',
      color2: '#43a2ca',
      color1: '#0868ac',
      mirror: false,
    },
    {
      value: '7',
      color6: '#0868ac',
      color5: '#43a2ca',
      color4: '#7bccc4',
      color3: '#a8ddb5',
      color2: '#ccebc5',
      color1: '#f0f9e8',
      mirror: true,
    },
    {
      value: '8',
      color6: '#f1eef6',
      color5: '#d4b9da',
      color4: '#c994c7',
      color3: '#df65b0',
      color2: '#dd1c77',
      color1: '#980043',
      mirror: false,
    },
    {
      value: '9',
      color6: '#980043',
      color5: '#dd1c77',
      color4: '#df65b0',
      color3: '#c994c7',
      color2: '#d4b9da',
      color1: '#f1eef6',
      mirror: true,
    },
  ];
  /**
   * @brief An integer representing the current color scheme.
   */
  var _nCurrentScheme = 0;

  /**
   * @fn _sortAscending
   * @brief 	Sort numeric data in ascending order.
   * @details Pass this sort function in the array.sort() function to sort the array in ascending manner.
   * @param	a: A value from the array.
   * @param	b: The next value after a from the array.
   * @return 	An array of sorted objects. NOTE: The array itself is changed as well.
   */
  var _sortAscending = function(a, b) {
    return a - b;
  };

  /**
   * @fn _sortDescending
   * @brief 	Sort numeric data in descending order.
   * @details Pass this sort function in the array.sort() function to sort the array in descending manner.
   * @param	a: A value from the array.
   * @param	b: The next value after a from the array.
   * @return 	An array of sorted objects. NOTE: The array itself is changed as well.
   */
  var _sortDescending = function(a, b) {
    return b - a;
  };

  /**
   * @fn 		_createLabel
   * @brief 	Function to help create a legend label for the appropriate values.
   * @detail 	Determines the appropriate legend value based on parameters.
   * @param 	nMin: Minimum Value for the label.
   * @param 	nMax: Maximum Value for the label.
   * @param 	nGroupNum: Integer specifying which Break is it on.
   * @param 	bLastValue: Boolean specifying whether this is the last value or not.
   * @return 	A string reprenting the label.
   */
  var _createLabel = function(nMin, nMax, nBreakNum, bLastValue) {
    //Declare Important Variables.
    var strLabel = '';

    if (nMin == nMax) {
      strLabel = nMin;
    } else if (bLastValue) {
      strLabel = nMin + Config.getUniversalString('higher');
    } else if (nBreakNum == 0) {
      strLabel = Config.getUniversalString('upTo') + nMax;
    } else {
      strLabel = nMin + Config.getUniversalString('to') + nMax;
    }

    return strLabel;
  };

  /**
   * @fn 		_getUniqueSortedValues
   * @brief 	Function to obtain all the unique values in an array.
   * @detail
   * @param 	arrValues: An array of values.
   * @return 	An array of all the unique values.
   */
  var _getUniqueSortedValues = function(arrValues) {
    var arrUniqueSortedVals = [];

    //Determine all the unique values.
    $.each(arrValues, function(index, val) {
      //If it is a unique value, add it.
      if (arrUniqueSortedVals.indexOf(val) == -1) {
        arrUniqueSortedVals.push(val);
      }
    });

    //Sort the unique value array.
    arrUniqueSortedVals.sort(_sortAscending);

    return arrUniqueSortedVals;
  };

  /**
   * @fn _calculateSDBC
   * @brief 	Calculate the sum of squared deviations between classes (SDBC).
   * @details
   * @param	arrBuckets: Array of buckets.
   * @return 	An integer representing the SDBC.
   */
  var _calculateSDBC = function(arrBuckets) {
    var nSDBC = 0;

    //Loop through the buckets to calculate each Standard deviation between classes.
    for (var nIndex = 0; nIndex < arrBuckets.length - 1; nIndex++) {
      nSDBC += Math.pow(arrBuckets[nIndex + 1].average - arrBuckets[nIndex].average, 2);
    }

    nSDBC = Math.sqrt(nSDBC / (arrBuckets.length - 1));

    return nSDBC;
  };

  /**
   * @fn _calculateDiscreteBreaks
   * @brief 	Calculates Discrete breaks in the data.
   * @details Discrete breaks just places the sorted data in sequence assinging the appropriate color.
   * @param	arrValues: Array of values for which the breaks need to be generated.
   * @param: 	nBreakPoints: Number of break points. Used to calculate breaks.
   * @return 	An array of objects.
   */
  var _calculateDiscreteBreaks = function(arrValues, nBreakPoints, nPrecision) {
    //Declare Important Variables.
    var arrLegendItems = [];

    $.each(arrValues, function(index, val) {
      var objNew = {};
      objNew[_MIN] = val;
      objNew[_MAX] = val;
      objNew[_LABEL] = val;
      objNew[_COLOR] = _arrLengendSchemes[_nCurrentScheme][index];
      arrLegendItems.push(objNew);
    });

    return arrLegendItems;
  };

  /**
   * @fn _calculateQuantileBreaks
   * @brief 	Calculates Quantile breaks in the data.
   * @details Calculates the breaks and create an array of objects containing the breaks and values.
   * @param	arrValues: Array of values for which the breaks need to be generated.
   * @param: 	nBreakPoints: Number of break points. Used to calculate breaks.
   * @return 	An array of objects.
   */
  var _calculateQuantileBreaks = function(arrValues, nBreakPoints, nPrecision) {
    //Declare Important Variables.
    var arrLegendItems = [];
    var arrValuesCopy = arrValues.slice(0);
    var nLastMaxVal = 0;

    //Check to make sure their are values.
    if (arrValuesCopy.length > 0) {
      //Sort Values.
      arrValuesCopy.sort(_sortAscending);

      //Determine what the bucket size is.
      var nBucketSize = Math.ceil(arrValuesCopy.length / nBreakPoints);

      //Loop through the values creating buckets for each break point/color.
      for (var nCurBreakPoint = 0; nCurBreakPoint < nBreakPoints; nCurBreakPoint++) {
        //Continue only if there are elements.
        if (arrValuesCopy.length) {
          //Obtain nBucketSize number of elements.
          var arrTemp = arrValuesCopy.splice(0, nBucketSize);
          var bRepeatItems = false;

          //If the next element in the values array is a repeat of the last element
          //in this particular bucket, then deal with it to make sure you do not
          //split the same value into multiple buckets.
          while (arrValuesCopy.length > 0 && arrValuesCopy[0] == arrTemp[arrTemp.length - 1]) {
            arrValuesCopy.shift();
            bRepeatItems = true;
          }

          //If an item has been repeated, update the bucket size.
          if (bRepeatItems) {
            nBucketSize = Math.ceil(arrValuesCopy.length / (nBreakPoints - nCurBreakPoint - 1));
          }

          //Reverse color ramp if needed.
          let arrLegendScheme = _arrLengendSchemes[_nCurrentScheme];
          if (_nCurrentScheme % 2 == 1) {
            const sliceStart = _MAX_COLOR_CHIPS - nBreakPoints;
            arrLegendScheme = _arrLengendSchemes[_nCurrentScheme].slice(sliceStart);
          }

          //Create the break details.
          var objNewBreak = {};
          //Assigning Minimum Value.
          if (nLastMaxVal == 0) {
            objNewBreak[_MIN] = parseFloat(arrTemp[0]).toFixed(nPrecision);
          } else {
            objNewBreak[_MIN] = (nLastMaxVal + 1 / Math.pow(10, nPrecision)).toFixed(nPrecision);
          }
          objNewBreak[_MAX] =
            arrValuesCopy.length > 0 ? parseFloat(arrTemp[arrTemp.length - 1]).toFixed(nPrecision) : Infinity;
          objNewBreak[_COLOR] = arrLegendScheme[nCurBreakPoint];
          objNewBreak[_LABEL] = _createLabel(
            objNewBreak[_MIN],
            objNewBreak[_MAX],
            nCurBreakPoint,
            arrValuesCopy.length == 0
          );

          arrLegendItems.push(objNewBreak);

          //Assign Last Max Value.
          nLastMaxVal = parseFloat(objNewBreak[_MAX]);
        }
      }
    }

    return arrLegendItems;
  };

  /**
   * @fn _calculateEqualBreaks
   * @brief 	Calculates Equal breaks in the data.
   * @details Calculates the breaks and create an array of objects containing the breaks and values.
   * @param	arrValues: Array of values for which the breaks need to be generated.
   * @param: 	nBreakPoints: Number of break points. Used to calculate breaks.
   * @return 	An array of objects.
   */
  var _calculateEqualBreaks = function(arrValues, nBreakPoints, nPrecision) {
    //Declare Important Variables.
    var arrLegendItems = [];
    var nSegMin = 0.0;
    var nSegMax = 0.0;

    //Check to make sure their are values.
    if (arrValues.length > 0) {
      //Obtain the Minimum and Maximum Values.
      var POWER = nPrecision > 0 ? Math.pow(10, nPrecision) : 1;
      var nMin = arrValues[0];
      var nMax = arrValues[arrValues.length - 1];

      //Calculate the length of each equal break.
      var nSegmentLength = (nMax - nMin) / nBreakPoints;

      //Go through all the values to create the labels.
      for (var nCurBreakPoint = 0; nCurBreakPoint < nBreakPoints; nCurBreakPoint++) {
        nSegMin = !nCurBreakPoint ? nMin : nSegMax + 1 / POWER;
        nSegMax =
          nCurBreakPoint == nBreakPoints - 1
            ? nMax
            : Math.floor((nMin + nCurBreakPoint * nSegmentLength) * POWER) / POWER;

        //Reverse color ramp if needed.
        let arrLegendScheme = _arrLengendSchemes[_nCurrentScheme];
        if (_nCurrentScheme % 2 == 1) {
          const sliceStart = _MAX_COLOR_CHIPS - nBreakPoints;
          arrLegendScheme = _arrLengendSchemes[_nCurrentScheme].slice(sliceStart);
        }

        //Create the break details.
        var objNewBreak = {};
        objNewBreak[_MIN] = parseFloat(nSegMin).toFixed(nPrecision);
        objNewBreak[_MAX] = parseFloat(nSegMax).toFixed(nPrecision);
        objNewBreak[_COLOR] = arrLegendScheme[nCurBreakPoint];
        objNewBreak[_LABEL] = _createLabel(
          parseFloat(nSegMin).toFixed(nPrecision),
          parseFloat(nSegMax).toFixed(nPrecision),
          nCurBreakPoint,
          nCurBreakPoint == nBreakPoints - 1
        );

        arrLegendItems.push(objNewBreak);
      }
    }

    return arrLegendItems;
  };

  /**
   * @fn _calculateNaturalBreaks
   * @brief 	Calculates Natural breaks in the data.
   * @details Calculates the breaks and create an array of objects containing the breaks and values.
   * @param	arrValues: Array of values for which the breaks need to be generated.
   * @param: 	nBreakPoints: Number of break points. Used to calculate breaks.
   * @return 	An array of objects.
   */
  var _calculateNaturalBreaks = function(arrValues, arrUniqueVals, nBreakPoints, nPrecision) {
    //Declare Important Variables.
    var arrValuesJenks = arrValues.slice(0);
    var arrValuesCopy = arrUniqueVals.slice(0);
    var arrJenkBreaks;
    var arrLegendItems = [];
    var nLastMaxVal = 0;

    if (arrValues.length > 0) {
      //arrJenkBreaks = ss.jenks(arrValuesJenks, nBreakPoints);
      var gs = new geostats();
      gs.setSerie(arrValuesJenks);
      gs.setPrecision(nPrecision);
      arrJenkBreaks = gs.getJenks(nBreakPoints);

      //splice the min value from the jenks array.
      arrJenkBreaks.splice(0, 1);

      //Create Labels.
      var nMin = 0;
      var nMax = 0;
      var strLabel = '';
      for (var nCurBreakPoint = 0; nCurBreakPoint < nBreakPoints; nCurBreakPoint++) {
        //Obtain the break value.
        var nBreakValue = arrJenkBreaks.splice(0, 1)[0];
        var bBreakFound = false;

        //Check if the break is the same value as the value in the original array.
        if (nBreakValue == arrValuesCopy[0]) {
          //Assign Minimum value.
          if (nLastMaxVal == 0) {
            nMin = parseFloat(nBreakValue).toFixed(nPrecision);
          } else {
            nMin = nLastMaxVal + 1 / Math.pow(10, nPrecision);
            nMin = nMin.toFixed(nPrecision);
          }
          nMax = parseFloat(nBreakValue).toFixed(nPrecision);
          strLabel = _createLabel(nMin, nMax, nCurBreakPoint, nCurBreakPoint == nBreakPoints - 1);
          arrValuesCopy.splice(0, 1);
        } else {
          //Assign Minimum value.
          if (nLastMaxVal == 0) {
            nMin = arrValuesCopy[0];
          } else {
            nMin = nLastMaxVal + 1 / Math.pow(10, nPrecision);
            nMin = nMin.toFixed(nPrecision);
          }

          //Look for maximum values.
          while (!bBreakFound) {
            arrValuesCopy.splice(0, 1);
            if (nBreakValue == arrValuesCopy[0]) {
              nMax = parseFloat(nBreakValue).toFixed(nPrecision);
              nMin = parseFloat(nMin).toFixed(nPrecision);
              strLabel = _createLabel(nMin, nMax, nCurBreakPoint, nCurBreakPoint == nBreakPoints - 1);
              bBreakFound = true;
              arrValuesCopy.splice(0, 1);
            }
          }
        }

        //Set Last Max Value.
        nLastMaxVal = parseFloat(nMax);

        //Reverse color ramp if needed.
        let arrLegendScheme = _arrLengendSchemes[_nCurrentScheme];
        if (_nCurrentScheme % 2 == 1) {
          const sliceStart = _MAX_COLOR_CHIPS - nBreakPoints;
          arrLegendScheme = _arrLengendSchemes[_nCurrentScheme].slice(sliceStart);
        }

        //Create the break object.
        var objNewBreak = {};
        objNewBreak[_MIN] = nMin;
        objNewBreak[_MAX] = nMax;
        objNewBreak[_COLOR] = arrLegendScheme[nCurBreakPoint];
        objNewBreak[_LABEL] = strLabel;

        arrLegendItems.push(objNewBreak);
      }
    }

    return arrLegendItems;
  };

  /**
   * @fn _calculateCustomBreaks
   * @brief 	Sets up custom breaks for renderer.
   * @details Takes user inputted break values and generates an array of objects containing the break values, colors and labels.
   * @param	customBreaks Array of values for which the breaks need to be generated.
   * @param nBreakPoints Number of break points. Used to calculate breaks.
   * @param nPrecision Number of break points. Used to calculate breaks.
   * @return 	An array of objects.
   */
  const _calculateCustomBreaks = (customBreaks, nBreakPoints, nPrecision) => {
    let prevMaxValue = 0;
    const arrLegendItems = [];

    for (let nCurBreakPoint = 0; nCurBreakPoint < nBreakPoints; nCurBreakPoint++) {
      //Create Labels.
      let nMin = -Infinity;
      let nMax = Infinity;
      let strLabel = '';
      // Handle final legend item, which will be 0.1 above the last custom entry
      if (nCurBreakPoint === nBreakPoints - 1) {
        nMin = prevMaxValue + 1 / Math.pow(10, nPrecision);
        nMin = nMin.toFixed(nPrecision);
        nMax = Infinity;
      } else {
        const value = customBreaks[nCurBreakPoint].value;

        // First break point
        if (nCurBreakPoint === 0) {
          nMax = parseFloat(value);
        } else {
          nMin = prevMaxValue + 1 / Math.pow(10, nPrecision);
          nMin = nMin.toFixed(nPrecision);
          nMax = parseFloat(value);
        }
        prevMaxValue = nMax;
      }

      strLabel = _createLabel(nMin, nMax, nCurBreakPoint, nCurBreakPoint + 1 == nBreakPoints);

      //Reverse color ramp if needed.
      let arrLegendScheme = _arrLengendSchemes[_nCurrentScheme];
      if (_nCurrentScheme % 2 == 1) {
        const sliceStart = _MAX_COLOR_CHIPS - nBreakPoints;
        arrLegendScheme = _arrLengendSchemes[_nCurrentScheme].slice(sliceStart);
      }

      //Create the break object.
      const objNewBreak = {};
      objNewBreak[_MIN] = parseFloat(nMin);
      objNewBreak[_MAX] = nMax;
      objNewBreak[_COLOR] = arrLegendScheme[nCurBreakPoint];
      objNewBreak[_LABEL] = strLabel;

      arrLegendItems.push(objNewBreak);
    }

    return arrLegendItems;
  };

  return {
    /**
     *	BREAK_TYPE: The type of break you want to calculate.
     */
    BREAK_TYPE: {
      Discrete: 'Discrete',
      Quantile: 'Quantile',
      Equal: 'Equal',
      Natural: 'Natural',
      Custom: 'Custom',
      'Equal Intervals': 'Equal',
      'Natural Breaks': 'Natural',
    },

    MIN: _MIN,
    MAX: _MAX,

    MAX_COLOR_CHIPS: _MAX_COLOR_CHIPS,
    /**
     * @fn getColorSchemes
     * @brief 	Obtains the color schemes in an arrray.
     * @details Returns an array or arrays containing the colors used in each scheme.
     * @param	nBreakPoints: Number of break points. Used to calculate number of colors in each scheme.
     * @return 	An array or schemes where each scheme is an array of color values.
     */
    getColorSchemes: function(nBreakPoints) {
      //Declare Important Variables.
      var arrSchemes = [];

      $.each(_arrLengendSchemes, function(nSchemeIndex, arrColors) {
        var arrFinalClrs = [];
        for (var nIndex = 0; nIndex < nBreakPoints; nIndex++) {
          arrFinalClrs.push(arrColors[nIndex]);
        }
        arrSchemes.push(arrFinalClrs);
      });
    },

    /**
     * @fn setColorScheme
     * @brief 	Set the color scheme currently being used.
     * @details
     * @param	nSchemeIndex: Index of which scheme to use as the current scheme. Index is 0 based.
     * @return 	void
     */
    setColorScheme: function(nSchemeIndex) {
      _nCurrentScheme = nSchemeIndex;
    },

    /**
     * @fn getCurrentColorScheme
     * @brief 	Get the color scheme currently being used.
     * @return 	integer representing the current color scheme.
     */
    getCurrentColorScheme: function() {
      return _nCurrentScheme;
    },

    /**
     * @fn calculateBreaks
     * @brief 	Calculates breaks of the data specifed.
     * @details Calculates the breaks and create an array of objects containing the breaks and values.
     * @param	arrValues: Array of values for which the breaks need to be generated.
     * @param: 	nBreakPoints: Number of break points. Used to calculate breaks.
     * @param: 	breakType: Break Type specifies the kind of break to calculate.
     * @return 	An array of objects.
     */
    calculateBreaks: function(arrValues, nBreakPoints, breakType, precision, customBreaks = {}) {
      //Declare Important Variables.
      var arrNumVals = [];
      var arrUniqueVals;
      var arrBreaks;

      //Convert to an array of intergers.
      for (var nIndex = 0; nIndex < arrValues.length; nIndex++) {
        var nTemp = parseFloat(arrValues[nIndex]);
        if (!isNaN(nTemp)) {
          arrNumVals.push(nTemp);
        }
      }

      //Obtain the unique values.
      arrUniqueVals = _getUniqueSortedValues(arrNumVals);
      //if unique values are less than or equal to breakpoints, then calculate discrete values.
      if (breakType !== mapLegend.BREAK_TYPE.Custom && arrUniqueVals.length <= nBreakPoints) {
        arrBreaks = _calculateDiscreteBreaks(arrUniqueVals, nBreakPoints, precision);
      } else {
        switch (breakType) {
          case mapLegend.BREAK_TYPE.Equal:
            arrBreaks = _calculateEqualBreaks(arrUniqueVals, nBreakPoints, precision);
            break;
          case mapLegend.BREAK_TYPE.Quantile:
            arrBreaks = _calculateQuantileBreaks(arrNumVals, nBreakPoints, precision);
            break;
          case mapLegend.BREAK_TYPE.Natural:
            arrBreaks = _calculateNaturalBreaks(
              arrNumVals.sort(_sortAscending),
              arrUniqueVals,
              nBreakPoints,
              precision
            );
            break;
          case mapLegend.BREAK_TYPE.Custom:
            arrBreaks = _calculateCustomBreaks(customBreaks[nBreakPoints - 3], parseInt(nBreakPoints), precision);
            break;
          default:
            console.log('Invalid Input for Break Calculation!');
            break;
        }
      }

      //Return breaks array.
      return arrBreaks;
    },

    getColorPalette: function() {
      return _arrObjLengendSchemes;
    },
  }; //END return 	{...
})();
